<template>
  <div class="pagination" v-if="total >= size">
    <!-- FIRST PAGE -->
    <span class="pagination__item" v-if="page > 3" @click="changePage(1)">
      <!-- <span class="icon">D</span> -->
      1
    </span>
    <span
      class="pagination__item"
      v-if="page > 3"
      @click="changePage(page - 1)"
    >
      <span class="icon">D</span>
    </span>
    <span
      class="pagination__item"
      v-if="page > 2"
      @click="changePage(page - 2)"
      >{{ page - 2 }}</span
    >
    <span
      class="pagination__item"
      v-if="page > 1"
      @click="changePage(page - 1)"
      >{{ page - 1 }}</span
    >
    <span class="pagination__item pagination__current">{{ page }}</span>
    <span
      class="pagination__item"
      v-if="page < Math.ceil(total / size) - 1"
      @click="changePage(page + 1)"
      >{{ page + 1 }}</span
    >
    <span
      class="pagination__item"
      v-if="page < Math.ceil(total / size) - 2"
      @click="changePage(page + 2)"
      >{{ page + 2 }}</span
    >
    <span
      class="pagination__item"
      v-if="page < Math.ceil(total / size) - 2"
      @click="changePage(page + 1)"
    >
      <span class="icon">V</span>
    </span>
    <!-- LAST PAGE -->
    <span
      class="pagination__item"
      v-if="page !== Math.ceil(total / size) && Math.ceil(total / size)"
      @click="changePage(Math.ceil(total / size))"
    >
      <span v-if="page < Math.ceil(total / size) - 2">{{
        Math.ceil(total / size)
      }}</span>
      <template v-else>{{ Math.ceil(total / size) }}</template>
    </span>
  </div>
</template>

<script>
export default {
  props: ['total', 'size'],
  computed: {
    page() {
      return parseInt(this.$route.query.page) || 1;
    },
  },
  methods: {
    changePage(p) {
      this.$router.push({
        path: this.$route.path,
        query: { ...this.$route.query, page: p },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/scss/base.scss';
.pagination {
  display: flex;
  justify-content: flex-end;
  padding: 10px 0;
  width: 100%;
  .pagination__item {
    align-items: center;
    background-color: $mainColor;
    border-radius: 2px;
    color: #fff;
    cursor: pointer;
    display: inline-flex;
    justify-content: center;
    height: 30px;
    margin: 0 2px;
    min-width: 30px;
    padding: 0 0.4rem;
    @include noselect();
    @include hover();
    .icon {
      font-size: 0.8rem;
    }
    &.pagination__current {
      background-color: $lightAccent;
    }
  }
}
</style>
